import script from "./IAcquirings.vue?vue&type=script&setup=true&lang=js"
export * from "./IAcquirings.vue?vue&type=script&setup=true&lang=js"

import "./IAcquirings.vue?vue&type=style&index=0&id=d4ea0b16&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d4ea0b16"]])

export default __exports__